import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';
import { postNewTradeOffer } from '../../../actions/postedOffersActions';

class ConfirmTradePostingModal extends React.Component {
  componentWillUnmount() {
    this._handleHideModal();
  }

  render() {
    const { id } = this.props;

    return (
      <Modal id={ id }>
        <div className='modal__header'>
                    Are you sure?
        </div>

        <div>
                    Are you sure you want to trade this appointment?
        </div>

        <div className='modal__actions'>
          <Button className='form__button form__button--purple'  onClick={ this._handleAcceptTradeOffer } type='button'>Yes</Button>
          <Button className='form__button form__button--green' onClick={ this._handleHideModal } type='button'>No</Button>
        </div>
      </Modal>
    );
  }

  _handleHideModal = () => {
    const { hideTooltip, id } = this.props;

    hideTooltip(id);
  };

  _handleAcceptTradeOffer = () => {
    const { appointmentId, postAppointmentToOffer } = this.props;

    postAppointmentToOffer(appointmentId);
    this._handleHideModal();
  };
}

ConfirmTradePostingModal.propTypes = {
  appointmentId: PropTypes.string,
  hideTooltip: PropTypes.func.isRequired,
  id: PropTypes.string,
  postAppointmentToOffer: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideTooltip: (id) => dispatch(tooltipHide({ id })),
    postAppointmentToOffer: (appointmentId) => dispatch(postNewTradeOffer({ appointmentId }))
  };
};

export default connect(null, mapDispatchToProps)(ConfirmTradePostingModal);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_ConfirmTradePostingModal.jsx